/**
 * @packageDocumentation
 * @module HackerAPI.Event.Submission
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import User from "../../user/user";
/**
 * A data container for an event submission
 * @class
 * @extends { HackerAPI.Base }
 */
var Submission = /** @class */ (function (_super) {
    __extends(Submission, _super);
    /**
     * Creates a new Submission object
     * @constructor
     * @param submission
     */
    function Submission(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, event_id = _b.event_id, eventId = _b.eventId, users = _b.users, url = _b.url, repository_urls = _b.repository_urls, repositoryUrls = _b.repositoryUrls, location = _b.location, user_ids = _b.user_ids, userIds = _b.userIds, contact_info = _b.contact_info, contactInfo = _b.contactInfo;
        var _this = _super.call(this, {
            users: Base.doNotSendHandler
        }) || this;
        /**
         * The ID of the submission
         * @type { number }
         */
        _this.id = id;
        /**
         * The name of the submission
         * @type { string }
         */
        _this.name = name;
        /**
         * The ID of the event the submission is for
         * @type { number }
         */
        _this.eventId = event_id || eventId;
        /**
         * The users making the submission
         * @type { HackerAPI.User[] }
         */
        _this.users = users || [];
        // Come up with better solution later
        _this.users.map(function (user) { return new User(user); });
        /**
         * The IDs of the users making the submission
         * @type { number[] }
         */
        _this.userIds = user_ids || userIds || [];
        /**
         * The devpost url of the submission
         * @type { string }
         */
        _this.url = url;
        /**
         * The repo urls of the submission
         * @type { string[] }
         */
        _this.repositoryUrls = repository_urls || repositoryUrls || [];
        /**
         * The location the submission is from
         * @type { string }
         */
        _this.location = location;
        /**
         * The method of contacting the users who made the submission
         * @type { string }
         */
        _this.contactInfo = contact_info || contactInfo;
        return _this;
    }
    /**
     * Gets all the submissions for an event
     * @param event - The event to get submissions for
     * @param event.slug
     * @param [token]
     * @param [token.token]
     * @returns The list of submissions for the event
     */
    Submission.fetchAll = function (_a, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/submissions",
            method: "GET",
            token: token
        }).then(function (data) {
            return data.map(function (datum) { return new Submission(datum); });
        });
    };
    /**
     * Fetches a submission on hackerapi
     * @param event - The event to get a submission for
     * @param event.slug
     * @param submission - The submission to get
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Submission.fetch = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/submissions/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Submission(data); });
    };
    /**
     * Adds a submission to hackerapi
     * @param event - The event to add a submission for
     * @param event.slug
     * @param submission - The submission to push
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Submission.create = function (_a, submission, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/submissions",
            method: "POST",
            body: submission.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Submission(data); });
    };
    /**
     * Updates a submission on hackerapi
     * @param event - The event to update a submission for
     * @param event.slug
     * @param submission - The submission to update
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Submission.update = function (_a, submission, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/submissions/" + submission.id,
            method: "PUT",
            body: submission.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Submission(data); });
    };
    /**
     * Deletes a submission
     * @param event - The event the submission is for
     * @param event.slug
     * @param submission - The submission to delete
     * @param update.id
     * @param [token]
     * @param [token.token]
     * @returns
     */
    Submission.delete = function (_a, _b, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/submissions/" + id,
            method: "DELETE",
            token: token
        });
    };
    return Submission;
}(Base));
export default Submission;
//# sourceMappingURL=submission.js.map